package org.beatonma.orbitals.render.renderer

import org.beatonma.orbitals.core.fastForEach
import org.beatonma.orbitals.core.physics.Acceleration
import org.beatonma.orbitals.core.physics.Body
import org.beatonma.orbitals.core.physics.Mass
import org.beatonma.orbitals.core.physics.Motion
import org.beatonma.orbitals.core.physics.Particle
import org.beatonma.orbitals.core.physics.Position
import org.beatonma.orbitals.core.physics.ZeroAcceleration
import org.beatonma.orbitals.core.physics.kg
import org.beatonma.orbitals.core.physics.metres
import org.beatonma.orbitals.render.CanvasDelegate
import org.beatonma.orbitals.render.OrbitalsRenderer
import org.beatonma.orbitals.render.color.Color
import org.beatonma.orbitals.render.options.Options

private typealias Size = Pair<Int, Int>

private val DefaultSpacing = 32
private val GridNodeMass = 1f.kg

class FieldRenderer<Canvas> internal constructor(
    override val delegate: CanvasDelegate<Canvas>,
    override var options: Options,
) : OrbitalsRenderer<Canvas> {
    private val grid: MutableList<Particle> = mutableListOf()
    private var size: Size = Pair(0, 0)

    override fun drawBody(canvas: Canvas, body: Body, props: BodyProperties) {}
    override fun drawForeground(canvas: Canvas, bodies: List<Body>, bodyProps: BodyPropertyMap) {}

    override fun drawBackground(canvas: Canvas, bodies: List<Body>, bodyProps: BodyPropertyMap) {
        val size = delegate.sizeOf(canvas)
        if (this.size != size) {
            rebuildGrid(size)
        }

        grid.fastForEach {
            val acceleration = it.netAccelerationTo(bodies, G = options.physics.G)
            renderAcceleration(
                canvas,
                acceleration,
                Color.White,
                it.position,
                4f,
                .2f,
                DefaultAccelerationScale / 2
            )
        }
    }

    private fun rebuildGrid(size: Size) {
        this.size = size
        val (width, height) = size
        grid.clear()

        val spacing = maxOf(DefaultSpacing, width / 30, height / 30)

        for (x in 0 until width step spacing) {
            for (y in 0 until height step spacing) {
                grid += particle(x, y)
            }
        }
    }
}


private fun Particle.netAccelerationTo(bodies: List<Body>, G: Float): Acceleration {
    var netAcceleration = ZeroAcceleration
    bodies.fastForEach {
        netAcceleration += gravitationalAccelerationTowards(it, G)
    }
    return netAcceleration
}


private fun particle(x: Int, y: Int) = object : Particle {
    override var mass: Mass = GridNodeMass
    override val motion: Motion = Motion(
        position = Position(x.toFloat().metres, y.toFloat().metres)
    )
}
